// execute above function
//initPhotoSwipeFromDOM('div.gallery');
import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js';
import PhotoSwipeDynamicCaption from './photoswipe-dynamic-caption-plugin.esm.js';

const lightbox = new PhotoSwipeLightbox({
  gallery: 'div.gallery',
  children: 'figure.gallery-photo',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  showAnimationDuration: 0,
  hideAnimationDuration: 0,
  pswpModule: () => import('./photoswipe.esm.min.js')
});
lightbox.addFilter('useContentPlaceholder',
                   (useContentPlaceholder, content) => { return false; });
const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
  // Plugins options, for example:
  type: 'auto',
});
lightbox.init();
